import React           from 'react';
import styled, { css } from 'styled-components';
import { INavItem }    from '@utils/navigation';

const Wrapper = styled.div`
  display          : flex;
  position         : fixed;
  top              : 64px;
  padding          : 14px 30px 0;
  width            : 100%;
  height           : 42px;
  box-shadow       : 0 0 8px #C5C5C5;
  z-index          : 88;
  background-color : ${({ theme: { backgroundColor } }): string => backgroundColor.white};
  transition       : padding .6s ease;

  @media (min-width: 960px) {
    top     : 90px;
    height  : 56px;
    padding : 20px 30px 0;
  }

  @media (min-width: 1280px) {
    padding : 20px 100px 0;
  }
`;

const NavItem = styled.h2`
  font-size     : 15px;
  margin-right  : 15px;
  white-space   : nowrap;
  overflow      : hidden;
  text-overflow : ellipsis;
  color         : ${({ active, theme: { textColor } }: any): string => (active && textColor.red)};

  :hover {
    ${({ active }: any): any => !active && css`
      text-decoration : underline;
      cursor          : pointer;
    `}
  }

  @media (min-width: 960px) {
    font-size    : 18px;
    margin-right : 25px;
  }
` as any;

export const NavBar = ({
  navigation,
  history: {
    push,
    location: {
      pathname,
    },
  },
}: any): JSX.Element => (
  <Wrapper>
    {navigation.map((x: INavItem): JSX.Element => {
      const { path, crumb } = x;
      const active = pathname.includes(`/${crumb}`);

      return (
        <NavItem
          key     = {crumb}
          active  = {active}
          onClick = {(): void => path && !active && push(path)}
        >
          {x.title}
        </NavItem>
      );
    })}
  </Wrapper>
);
